import React, { useState } from "react";
import { FaVideo } from "react-icons/fa";
require("../../assets/stylesheets/Main/Timer.css");

function Timer({ month, day, year, hour, waitingMessage, endMessage, link }) {
  const [daysDate, setDaysDate] = useState("");
  const [hoursDate, setHoursDate] = useState("");
  const [minutesDate, setMinutesDate] = useState("");
  const [secondsDate, setSecondsDate] = useState("");
  const [timerMessage, setTimerMessage] = useState("");
  const [timerVisibility, setTimerVisibility] = useState("");
  const [linkVisibility, setLinkVisibility] = useState("");
  const [eventLink, setEventLink] = useState("");

  var countDownDate = new Date(`${month} ${day}, ${year} ${hour}`).getTime();

  var x = setInterval(function () {
    var now = new Date().getTime();

    var distance = countDownDate - now;

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    setTimerVisibility("timer");
    setLinkVisibility("hide");
    setDaysDate(days);
    setHoursDate(hours);
    setMinutesDate(minutes);
    setSecondsDate(seconds);
    setTimerMessage(waitingMessage);
    setEventLink(link);

    if (distance < 0) {
      clearInterval(x);
      setTimerMessage(endMessage);
      setDaysDate("0");
      setHoursDate("0");
      setMinutesDate("0");
      setSecondsDate("0");
      setLinkVisibility("link");
      setTimerVisibility("hide");
    }
  }, 1000);

  return (
    <div className="timer-container">
      <div className={`${timerVisibility}`}>
        <span>
          {daysDate} <p>D</p>
        </span>
        <span>
          {hoursDate} <p>H</p>
        </span>
        <span>
          {minutesDate} <p>M</p>
        </span>
        <span>
          {secondsDate} <p>S</p>
        </span>
      </div>
      <div className="message">
        <span>{timerMessage}</span>
      </div>
      <a href={`${eventLink}`} target="_blank">
        <div className={`${linkVisibility}`}>
          {/* <span>
            <FaVideo /> &nbsp; ENTRAR
          </span> */}
        </div>
      </a>
    </div>
  );
}

export default Timer;
